import ServiceActuator from "@/services/service-actuator";
import {SET_BUILD} from './types';

export async function getMetrics({commit}) {
  const {data} = await ServiceActuator.getMetrics();
  commit(SET_BUILD, data.build);
  return data;
}